/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Directive, Input, ElementRef, Renderer, HostBinding, Optional, Self } from '@angular/core';
import { NgForm } from '@angular/forms';
import classNames from 'classnames';

import { AbstractForm } from './abstract.form';
export class FormDirective extends AbstractForm {
/**
 * 样式前缀
 */
prefixCls = 'ant-form';
/**
 * 表单布局，可选值为`horizontal`, `vertical`, `inline`，默认为`horizontal`
 */
layout: 'horizontal' | 'inline' | 'vertical' = 'horizontal';
/**
 * 隐藏所有表单项的必选标记
 */
hideRequiredMark = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} form
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
          form: NgForm) {
        super(form);
    }
/**
 * @return {?}
 */
get classes(): string {
        return this.getFormClasses();
    }
/**
 * @return {?}
 */
getFormClasses(): string {
        return classNames(this.prefixCls, {
            [`${this.prefixCls}-horizontal`]: this.isHorizontal(),
            [`${this.prefixCls}-vertical`]: this.isVertical(),
            [`${this.prefixCls}-inline`]: this.isInline(),
            [`${this.prefixCls}-hide-required-mark`]: this.hideRequiredMark,
        }, this.class);
    }
/**
 * @return {?}
 */
isVertical(): boolean {
        return this.layout === 'vertical';
    }
/**
 * @return {?}
 */
isHorizontal(): boolean {
        return this.layout === 'horizontal' || this.layout == null;
    }
/**
 * @return {?}
 */
isInline(): boolean {
        return this.layout === 'inline';
    }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // tslint:disable-next-line:directive-selector
    selector: 'form',
    exportAs: 'faForm'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: NgForm, decorators: [{ type: Optional }, { type: Self }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'layout': [{ type: Input },],
'hideRequiredMark': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function FormDirective_tsickle_Closure_declarations() {
/** @type {?} */
FormDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormDirective.ctorParameters;
/** @type {?} */
FormDirective.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
FormDirective.prototype.prefixCls;
/**
 * 表单布局，可选值为`horizontal`, `vertical`, `inline`，默认为`horizontal`
 * @type {?}
 */
FormDirective.prototype.layout;
/**
 * 隐藏所有表单项的必选标记
 * @type {?}
 */
FormDirective.prototype.hideRequiredMark;
/**
 * 用户CSS样式
 * @type {?}
 */
FormDirective.prototype.class;
/** @type {?} */
FormDirective.prototype._renderer;
/** @type {?} */
FormDirective.prototype._elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
